import z from 'zod';
import { CaseSchema, GetParamsSchema } from './shared';

export type Case = z.infer<typeof CaseSchema>;

export const ResponseSchema = z.object({ cases: z.array(CaseSchema) }).describe('An array of cases');

export type Response = z.infer<typeof ResponseSchema>;

export const ParamsSchema = GetParamsSchema.extend({
  case: z.number().optional(),
  appt: z.number().optional(),
  patient: z
    .string()
    .max(40)
    .regex(/^{?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}}?$/)
    .optional(),
  clin_guid: z
    .string()
    .max(40)
    .regex(/^{?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}}?$/)
    .optional(),
  status: z.string().optional(),
  first_incomplete: z.string().optional(),
  active: z.boolean().optional(),
  new_case: z.string().optional(),
  case_ref: z.string().max(128).optional(),
  client_id: z.number().optional(),
  client_name: z.string().optional(),
  patient_name: z.string().optional(),
  cat_code: z.string().max(30).optional(),
  cat_name: z.string().optional(),
  area_code: z.string().max(30).optional(),
  area_name: z.string().optional(),
  clin_type: z.string().max(100).optional(),
  clinician: z.string().optional(),
  client_code: z.string().max(30).optional(),
  date_start: z.string().datetime({ offset: true }).optional(),
  date_end: z.string().datetime({ offset: true }).optional(),
  overdue_only: z.string().optional()
});
